<mat-drawer-container class="drawer-container" [hasBackdrop]="true">
    <mat-drawer #drawer mode="side" position="end" class="drawer-filtro" (closedStart)="fecharDrawer()"
        [opened]="filtroAberto || filtroPedidosAberto">

        <ng-container [class.hidden]="!filtroAberto">
            <app-filters></app-filters>
        </ng-container>

        <ng-container [class.hidden]="!filtroPedidosAberto">
            <div>
                teste
            </div>
        </ng-container>

    </mat-drawer>
</mat-drawer-container>